
import axios from "axios";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      // keywordcheck: false,
      status_sas: false,
      max_topic: 0,
      max_keyword: 0,
      name_topic_dialog: '',
      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",


      buttonAddKeyword: true,
      deleteact: false,
      insertact: false,
      updateact: false,
      viewact: false,

      search: '',
      dialog: false,
      dialoginformasitopic: false,
      dialogedittopic: false,
      dialoginformasikeyword: false,
      dialogeditkeyword: false,
      dialogprivilege: false,
      dialogDelete: false,
      // keywordstatusselect: ['Enabled', 'Disabled'],

      
      width_form_keyword: '400px',
      collect_news_val: true,
      collect_twit_val: true,
      collect_ig_val: true,
      collect_fb_val: true,
      collect_threads_val: true,
      collect_tiktok_val: true,
      collect_ytb_val: true,
      
      
      keywordstatus :1,
      keywordstatusedit: [//choice select
              {value_edit: 1, name_edit: "Enabled" },
              {value_edit: 0, name_edit: "Disabled" }
      ],

      topicstatus_topic :1,
      status_topic_insert: [//choice select
              {value_topic: 1, name_topic: "Enabled" },
              {value_topic: 0, name_topic: "Disabled" }
      ],
      topicstatus :1,
      keywordstatusselect: [//choice select
              {value: 1, name: "Enabled" },
              {value: 0, name: "Disabled" }
      ],
      // privilege: ['Admin', 'Staff'],
      
      privilege_insert: [
            {
              value_privilege_insert: '', 
              name_privilege_insert: '' 
            }
      ],
      
      privilege: [
            {
              value_privilege_edit: '', 
              name_privilege_edit: '' 
            }
      ],
      rolestatus: ['Enabled', 'Disabled'],
      keyword: ['Banjir', 'Tanah Longsor', 'Politik'],
      headers: [
        { text: 'No', value: 'NO_URUT' },
        { text: 'Topic Name', value: 'GROUP_NAME' },
        { text: '', value: 'infotopic', sortable: false },
        { text: 'Status', value: 'GROUP_STATUS_TEXT'  },
        { text: '', value: 'editstatus', sortable: false , width: '120px'  },
        { text: 'Keyword', value: 'KEYWORD_ARR' },
        { text: '', value: 'infokeyword', sortable: false, width: '170px' },
        //{ text: 'Seen Privilege', value: 'KEYWORD_PRIVILAGE_ARR', width: '200px'  },
        //{ text: '', value: 'editprivilege', sortable: false },
      ],
      
      item_insert_dinamis: [
        {keywordname : ''}
      ],
      
      item_edit_keyword_dinamis: [
        {keywordname : '',id_keyword : '',status : '',checknews : '',checktwet : '',checkytb : '',checktiktok : '',checkig : '',checkfb: '',checkthreads: ''}
      ],
      
      item_edit_privilage_dinamis: [
        {privilagename : '',id_role_privilage : '',id_privilage : ''}
      ],
      
      
      id_keyword: [],
      topic: [],
      table: [],
      id_topic: '',
      createnametopic: '',
      createdatetopic: '',
      updatenametopic: '',
      updatedatetopic: '',

      
      createnamekeyword: '',
      createdatekeyword: '',
      updatenamekeyword: '',
      updatedatekeyword: '',
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
      showNoData: false,
      noDataMessage: ''
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Add '+this.$store.state.title : 'Update '+this.$store.state.title
      },
    },
    watch: {
      
      dialogprivilege(val){
        val || this.closeprivilageDialog()
      },
      dialogeditkeyword(val){
        
        val || this.closekeywordDialog()
      },
      
      dialoginformasikeyword(val){
        
        val || this.closeInformasikeywordDialog()
      },
      
      dialoginformasitopic(val){
        val || this.closeInformasiTopicDialog()
      },
      dialogedittopic(val){
        val || this.closeTopicDialog()
      },
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      
      
    getColor(status) {
      return status === 'Disabled' ? 'red' : 'green';
    },
    initialize () {
        this.tableLoading = true;
        axios.get("topic-keyword",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }

            let res = decryptionData(response.data.token);
            this.status_sas = res.status_sas;  
            this.max_topic = res.max_topic;  
            this.max_keyword = res.max_keyword;  
            if(this.status_sas == true){
              if(res.data.length >= this.max_topic){
                this.insertact = false
              }
            }

            if (res.status === 201) {
              this.topic = [];  
              this.noDataMessage = res.messages;
              this.showNoData = true;
              this.tableLoading = false;
              return; 
            }
            this.showNoData = false;
            // ➤ Tambahkan nomor urut permanen
            this.topic = res.data.map((item, index) => ({
              ...item,
              NO_URUT: index + 1   // nomor urut tetap
            }));
            // ----- selected role privilage ----
            let result = '';
            let arr_data = [];
            let result_edit = '';
            let arr_data_edit = [];
            if(res.send_privilage.length > 0){
              for (let i = 0; i <  res.send_privilage.length; i++) {  
                  if(i == 1){
                    this.topic_id = (res.send_privilage[i].SEQ_ID);
                  }
                  result = {
                    name_privilege_insert : res.send_privilage[i].ROLE_NAME,
                    value_privilege_insert : res.send_privilage[i].SEQ_ID
                  };
                  arr_data.push(result);
                  
                  result_edit = {
                    name_privilege_edit : res.send_privilage[i].ROLE_NAME,
                    value_privilege_edit : res.send_privilage[i].SEQ_ID
                  };
                  arr_data_edit.push(result_edit);
              }
              // console.log(arr_data);
              this.privilege_insert= arr_data;
              this.privilege = arr_data_edit;
            }
            // ----- end selected role privilage ----
            setTimeout(() =>{
              this.loading = false
            // end loading 
            },1000)
            this.tableLoading = false;
          })
          .catch((e) => {
              switch (e.response.status) {
               
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      saveinsert () {
        axios.post("/insert-topic-keyword", 
            {
              group_name:this.editedItem.topicname,
              status:this.topicstatus_topic,
              keyword:this.item_insert_dinamis,
              keyword_role_privilage:this.editedItem.topicstatus,
              status_sas:this.status_sas
            },
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize();
                this.$router.push('/topickeyword');
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
                this.editedItem = {};
                this.item_insert_dinamis = [
                  { keywordname : '' }
                ];
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    case 400:
                          this.alertFailed = true;
                          this.alert_err_attention =  e.response.data.msg;
                          this.btnload = false
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
      },
      
      close () {
        this.editedItem.topicname = '';
        this.topicstatus_topic = 1
        this.dialog = false
        this.$nextTick(() => {
          this.inputedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      add() {
        this.originalData = null
        this.item_insert_dinamis.push({ keywordname: '' })
      },
      remove(item, index) {
        if(index > 0){
          this.item_insert_dinamis.splice(index, 1)
        }else{
          alert('Baris Pertama tidak bisa dihapus');
        }
      },

      // =========================================== topik action =================================
      informasiItemTopic(item){
        this.id_topic = item;
        this.loading = true
        axios({
          method: "put",
          url: "/getid-topic-keyword",
          data: {
            seq_id_topic : item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            const dat = decryptionData(response.data.token);
            console.log(dat);
            this.createnametopic =dat.SYS_CREATED_BY; 
            this.createdatetopic =dat.SYS_CREATED_DATE; 
            this.updatenametopic =dat.SYS_UPDATED_BY; 
            this.updatedatetopic =dat.SYS_UPDATED_DATE; 
            this.dialoginformasitopic =true;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      
      closeInformasiTopicDialog(){
        this.dialoginformasitopic = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },
      
      editItemTopic (item){
        this.id_topic = item;
        this.loading = true
        axios({
          method: "put",
          url: "/getid-topic-keyword",
          data: {
            seq_id_topic : item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            const dat = decryptionData(response.data.token);
            this.editedItem.topicname = dat.GROUP_NAME;
            this.topicstatus =dat.GROUP_STATUS; 
            this.dialogedittopic =true;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        
      },
      saveedittopic(){
        axios.put("/update-topic-keyword", 
            {
              seq_id_topic:this.id_topic,
              neme_topic:this.editedItem.topicname,
              status_topic:this.topicstatus,
              status_sas:this.status_sas
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize();
                this.$router.push('/topickeyword');
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
          this.closeTopicDialog();
      },
      closeTopicDialog(){
        this.dialogedittopic = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },
      // =========================================== end topik action =================================
      // =========================================== Keyword action =================================
      informasiItemKeyword(item){
        // alert(item);
        this.id_topic = item;
        this.loading = true
        axios({
          method: "put",
          url: "/get-group-keyword-topic",
          data: {
            status_sas : this.status_sas,
            seq_id_topic : item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            const dat = decryptionData(response.data.token);
            if(dat.length > 0){
              this.createnamekeyword =dat[0].SYS_CREATED_BY; 
              this.createdatekeyword =dat[0].SYS_CREATED_DATE; 
              this.updatenamekeyword =dat[0].SYS_UPDATED_BY; 
              this.updatedatekeyword =dat[0].SYS_UPDATED_DATE; 
            }
            this.dialoginformasikeyword =true;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      
      closeInformasikeywordDialog(){
        this.dialoginformasikeyword = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },
      
      editItemKeyword (item,topic){
        this.name_topic_dialog = topic
        this.id_topic = item;
        this.loading = true
        axios({
          method: "put",
          url: "/get-group-keyword-topic",
          data: {
            status_sas : this.status_sas,
            seq_id_topic : item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            const dat = decryptionData(response.data.token);
            const collect_news = (response.data.collect_news);
            const collect_twetter = (response.data.collect_twetter);
            const collect_ytb = (response.data.collect_ytb);
            const collect_tiktok = (response.data.collect_tiktok);
            const collect_instagram = (response.data.collect_instagram);
            const cont_colect_active = (response.data.cont_colect_active);
            const collect_fb = (response.data.collect_fb);
            const collect_threads = (response.data.collect_threads);

            this.collect_news_val = collect_news;
            this.collect_twit_val = collect_twetter;
            this.collect_ig_val = collect_instagram;
            this.collect_tiktok_val = collect_tiktok;
            this.collect_ytb_val = collect_ytb;
            this.collect_fb_val = collect_fb;
            this.collect_threads_val = collect_threads;
            
            
            if(cont_colect_active == 1){
              this.width_form_keyword = '350px';
            }else  if(cont_colect_active == 2){
              this.width_form_keyword = '450px';
            }else  if(cont_colect_active == 3){
              this.width_form_keyword = '550px';
            }else  if(cont_colect_active == 4){

              this.width_form_keyword = '670px';
            }else  if(cont_colect_active == 5){
              this.width_form_keyword = '790px';

            }else  if(cont_colect_active == 6){
              this.width_form_keyword = '900px';

            }else  if(cont_colect_active == 7){
              this.width_form_keyword = '1100px';

            }

            if(dat.length > 0){
              //this.keywordstatus =dat[0].KEYWORD_STATUS
              this.keywordstatus =cont_colect_active
            }
            
            // ----- selected role privilage ----
            let result = '';
            let arr_data = [];
            if(dat.length > 0){
              for (let i = 0; i <  dat.length; i++) { 
                this.add_edit_keyword(); 
                  result = {
                    keywordname : dat[i].KEYWORD,
                    id_topic_keyword : dat[i].GROUP_ID,
                    id_keyword : dat[i].SEQ_ID,
                    status : dat[i].KEYWORD_STATUS,
                    checknews : dat[i].NEWS_FLAG,
                    checktwet : dat[i].TWITTER_FLAG,
                    checkytb : dat[i].YTB_FLAG,
                    checktiktok : dat[i].TIKTOK_FLAG,
                    checkig : dat[i].INSTAGRAM_FLAG,
                    checkfb : dat[i].FB_FLAG,
                    checkthreads : dat[i].THREADS_FLAG
                  };
                  arr_data.push(result);
              }
              this.item_edit_keyword_dinamis= arr_data;
            }else{
                  result = {
                    keywordname : '',
                    id_topic_keyword : '',
                    id_keyword : '',
                    status : '',
                    checknews : '',
                    checktwet : '',
                    checkytb : '',
                    checktiktok : '',
                    checkig : '',
                    checkfb : '',
                    checkthreads : '',
                    
                  };
                  arr_data.push(result);
                  this.item_edit_keyword_dinamis= arr_data;
            }
            // ----- end selected role privilage ----

            if(this.status_sas == true){
              if(this.item_edit_keyword_dinamis.length >= this.max_keyword){
                this.buttonAddKeyword = false
              }else{
                this.buttonAddKeyword = true

              }
            }
            this.dialogeditkeyword =true;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        
      },
      
      add_edit_keyword() {
        this.originalData = null
        this.item_edit_keyword_dinamis.push({ keywordname: '',checktwet:'' })
        if(this.status_sas == true){
          if(this.item_edit_keyword_dinamis.length >= this.max_keyword){
            this.buttonAddKeyword = false
          }
        }
            
      },
      checkedkeywordCollection(item,index,collection) {
        if(collection == 'NEWS'){
          if(item.checknews == undefined || item.checknews == false){
            item.checknews = false
          }
          if ( item.checknews == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checknews: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checknews: false });
          }
        }else if(collection == 'TWITTER'){
          if(item.checktwet == undefined || item.checktwet == false){
            item.checktwet = false
          }
          if ( item.checktwet == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checktwet: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checktwet: false });
          }

        }else if(collection == 'YOUTUBE'){
          if(item.checkytb == undefined || item.checkytb == false){
            item.checkytb = false
          }
          if ( item.checkytb == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkytb: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkytb: false });
          }
          
        }else if(collection == 'TIKTOK'){
          if(item.checktiktok == undefined || item.checktiktok == false){
            item.checktiktok = false
          }
          if ( item.checktiktok == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checktiktok: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checktiktok: false });
          }
          
        }else if(collection == 'INSTAGRAM'){
          if(item.checkig == undefined || item.checkig == false){
            item.checkig = false
          }
          if ( item.checkig == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkig: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkig: false });
          }
          
        }else if(collection == 'FACEBOOK'){
          if(item.checkfb == undefined || item.checkfb == false){
            item.checkfb = false
          }
          if ( item.checkfb == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkfb: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkfb: false });
          }
          
        }else if(collection == 'THREADS'){
          if(item.checkthreads == undefined || item.checkthreads == false){
            item.checkthreads = false
          }
          if ( item.checkthreads == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkthreads: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkthreads: false });
          }
          
        }
        
        console.log(this.item_edit_keyword_dinamis)

      },
      remove_edit_keyword(item, index) {
        if(index > 0){
          if(item.id_keyword != null){
            axios({
              method: "delete",
              url: "/delete-keyword-topic",
              data: {
                seq_id_keyword: item.id_keyword
              },
              headers:{'auth-token':localStorage.getItem('token_app')},
              dataType: 'json'
            })
            .then((response) => {
              // handle success
              this.editItemKeyword(item.id_topic_keyword);
              console.log(response);
              
              this.initialize();
            })
            .catch(function (error) {
              // handle error
              console.log(error);
            })
          }
          this.item_edit_keyword_dinamis.splice(index, 1)
          if(this.status_sas == true){
            if(this.item_edit_keyword_dinamis.length >= this.max_keyword){
              this.buttonAddKeyword = false
            }else{
              this.buttonAddKeyword = true

            }
          }
        }else{
          alert('Baris Pertama tidak bisa dihapus');
        }
      },


      
      saveeditkeyword(){
        axios.put("/update-group-keyword-topic", 
            {
              seq_id_topic:this.id_topic,
              keyword:this.item_edit_keyword_dinamis,
              status_sas:this.status_sas
              // keywors_status:this.keywordstatus
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize();
                this.$router.push('/topickeyword');
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.closekeywordDialog()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
      },
      
      closekeywordDialog(){
        this.dialogeditkeyword = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },

      // ============================================ end keyword action ===============================
      // =================================== privilage =================
      editItemPrivilage (item,topic){
        // alert(item);
        this.name_topic_dialog = topic
        console.log(topic)
        this.id_topic = item;
        this.loading = true
        axios({
          method: "put",
          url: "/get-group-privilage-topic",
          data: {
            seq_id_topic : item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            const dat = decryptionData(response.data.token);
            // ----- selected role privilage ----
            let result = '';
            let arr_data = [];
            if(dat.length > 0){
              for (let i = 0; i <  dat.length; i++) { 
                this.add_edit_privilage(); 
                  result = {
                    privilagename : dat[i].KEYWORD,
                    id_privilage : dat[i].SEQ_ID,
                    id_role_privilage : dat[i].ROLE_ID,
                    id_topic_keyword : dat[i].GROUP_ID,
                  };
                  arr_data.push(result);
              }
              // this.dialogprivilege= arr_data;
            }else{
                  result = {
                    privilagename : '',
                    id_privilage : '',
                    id_role_privilage : '',
                    id_topic_keyword : ''
                  };
                  arr_data.push(result);

            }
            this.item_edit_privilage_dinamis= arr_data;
            // ----- end selected role privilage ----
            this.dialogprivilege =true;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        
      },

      add_edit_privilage() {
        this.originalData = null
        this.item_edit_privilage_dinamis.push({ privilagename: '' ,id_role_privilage : '',id_privilage : ''})
        // this.editIndex = this.item_insert_dinamis.length - 1
      },

      remove_edit_privilage(item, index) {
        if(index > 0){
            if(item.id_privilage != null){
            axios({
              method: "delete",
              url: "/delete-group-privilage-topic",
              data: {
                seq_id_privilage: item.id_privilage
              },
              headers:{'auth-token':localStorage.getItem('token_app')},
              dataType: 'json'
            })
            .then((response) => {
              this.editItemPrivilage(item.id_topic_keyword);
              console.log(response);
              this.initialize();
            })
            .catch(function (error) {
              console.log(error);
            })
          }
          this.item_edit_privilage_dinamis.splice(index, 1)
        }else{
          alert('Baris Pertama tidak bisa dihapus');
        }
      },
      
      saveeditprivilage(){
        axios.put("/update-group-privilage-topic", 
            {
              seq_id_topic:this.id_topic,
              privilage:this.item_edit_privilage_dinamis
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize();
                this.$router.push('/topickeyword');
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.closePrivilageDialog()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
      },
      closePrivilageDialog(){
        this.dialogprivilege = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },
      
      deleteItem (item) {
        this.id_topic = item
        // alert(item);
        this.dialogDelete = true
      },
      
      deleteItemConfirm () {
        this.topic.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "/delete-group-topic",
          data: {
            seq_id_topic: this.id_topic
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.initialize ();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.closeDelete()
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
          } 
        })
        .catch(function (error) {
          console.log(error);
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.inputedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

    },
  }